module.exports = __webpack_public_path__ + "static/media/martha-stuckey.be43305b.md";